module.exports = __webpack_public_path__ + "img/studies_rubicon_biatorbagy_01.588e54aa.png";